import { Form as AntdForm, Select as AntdSelect } from 'antd'
import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import SelectArrowIcon from 'components/icons/SelectArrowIcon'
import React from 'react'
import styled from 'styled-components'
import isValidUUID from '../../utils/isValidUUID'
import CloseIcon from '../icons/CloseIcon'
import { EmptySpan } from '../UIComponents/CommonStyledDiv'

export const FormItem = styled(AntdForm.Item)`
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0px'} !important;
  width: 100%;
  .ant-form-item-explain-error {
    padding-left: ${props => (props.padding ? '15%' : '0')};
  }
`

const { Option } = AntdSelect

const StyledSelect = styled(AntdSelect)`
  width: 100% !important;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #010e30;

  .ant-select-selector {
    background-color: ${props =>
      !props.disabled
        ? props.backgroundcolor
          ? '#fafafb'
          : '#ffffff'
        : '#f5f5f5'} !important;
    border-radius: 8px !important;
    border-color: #e9e9e9 !important;
    box-shadow: none !important;
  }
  .ant-select-selection-item {
    background-color: ${props =>
      !props.disabled
        ? props?.mode === 'multiple' || props?.mode === 'tags'
          ? '#ebecee'
          : '#ffffff'
        : '#f5f5f5'};
    border-radius: 6px;
    color: ${props => !props.disabled && '#010e30'};
  }
  .ant-select-multiple.ant-select-lg .ant-select-selection-item {
    background-color: ${props =>
      !props.disabled
        ? props?.mode === 'multiple' || props?.mode === 'tags'
          ? '#ebecee'
          : '#ffffff'
        : '#f5f5f5'};
  }
  :hover {
    border-radius: 6px;
    color: #010e30;
  }
  .ant-select-dropdown-placement-bottomLeft {
    width: 1000px !important;
  }
  .ant-select-selection-item-remove {
    display: flex;
    align-items: center;
  }
  .ant-select-selection-placeholder {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }
`
const LabelWrapper = styled.div`
  padding-bottom: 8px;
`

const Select = ({
  OptionData,
  placeholder,
  labelStyle,
  onChange,
  label,
  value,
  position = 'relative',
  width = '100%',
  defaultValue,
  loading,
  bordered = true,
  valueParam = 'id',
  nameParam = 'name',
  showSearch = false,
  backgroundcolor,
  name,
  rules,
  mode,
  disabled = false,
  onSearch,
  id = 'select',
  error,
  ...rest
}) => {
  const renderTag = option => {
    return (
      !isValidUUID(option.label) && (
        <div
          className="ant-select-selection-overflow-item"
          style={{
            position: 'relative',
            opacity: 1,
            display: 'flex',
          }}
        >
          <span
            className="ant-select-selection-item ant-select-selection-item-disabled"
            style={{ lineHeight: '32px', height: '32px' }}
          >
            <span className="ant-select-selection-item-content">
              {' '}
              {option.label}
            </span>
            {!option.disabled && option.closable && (
              <EmptySpan
                className="ant-select-selection-item-remove"
                aria-hidden="true"
                onClick={option.onClose}
                style={{ userSelect: 'none', cursor: 'pointer' }}
              >
                <CloseIcon />
              </EmptySpan>
            )}
          </span>
        </div>
      )
    )
  }
  return (
    <FormItem name={name} rules={rules} {...rest} key={name}>
      <Flex
        column
        style={{
          width: width,
          position: position,
        }}
        id={id}
      >
        {label && (
          <LabelWrapper>
            <Label labelStyle={labelStyle}>{label}</Label>
          </LabelWrapper>
        )}

        <StyledSelect
          showSearch={showSearch}
          suffixIcon={<SelectArrowIcon />}
          placeholder={placeholder}
          onChange={onChange}
          size={'large'}
          value={value || undefined}
          loading={loading}
          bordered={bordered}
          defaultValue={defaultValue}
          backgroundcolor={!value}
          mode={mode}
          getPopupContainer={() => document.getElementById(`${id}`)}
          disabled={disabled}
          onSearch={onSearch}
          filterOption={(inputValue, option) =>
            option[nameParam]
              .toLowerCase()
              .indexOf(inputValue.toLowerCase()) !== -1
          }
          tagRender={renderTag}
          {...rest}
        >
          {OptionData?.map(option => {
            return (
              <Option
                style={{
                  padding: '10px 12px',
                }}
                key={option[valueParam]}
                value={option[valueParam]}
                id={option?.id}
                name={option[nameParam]}
                option={option}
                formName={name}
              >
                {option[nameParam]}
              </Option>
            )
          })}
        </StyledSelect>
      </Flex>
      {error && <span style={{ color: 'red', fontSize: '12px' }}>{error}</span>}
    </FormItem>
  )
}

export default Select
